export const LanguageKey = {
  DE: 'DE'
};

export const LANGUAGE_KEYS = Object.values(LanguageKey);

export default LanguageKey;
